<template>
  <Drawer title="中天-未检测到硬盘" width="1024"  :closable="false" v-model="_value">

    <Skeleton animated>
      <List item-layout="vertical">
        <ListItem v-for="item in data" :key="item.title">
          <ListItemMeta :title="item.title"/>
          {{ item.description }}<br/>
          {{ item.content }}<br/>
          {{ item.dispose }}
          <Button v-if="item.pdfSrc" type="primary" size="small" @click="openpdf(item.pdfSrc)" style="margin: 10px;">详细文档</Button>
          <iframe-modal v-model="Iframemodal" :initValue="IframeId"></iframe-modal>
          <template #extra>
            <img :src="item.imgSrc" style="width: 580px">
          </template>
        </ListItem>
      </List>
    </Skeleton>

  </Drawer>
</template>

<script>

/**
   * 引入自建组件/框架组件等位置
   */
import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

import IframeModal from '@/view/om/technicalassistance/components/iframe-modal'

export default {
  name: 'ztharddisknotdetectedmodal',
  /**
     * 与组件引入的组件名一致，使用该组件
     * 下面是引入自建组件例子
     */
  components: {
    IframeModal
  },
  /**
     * 作为组件对应传送字段
     */
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    },

    Iframemodal: false,
    IframeId: null
  },
  /**
     * 默认数据/字段名创建
     */
  data () {
    return {
      /**
         * 下面是引入自建组件例子
         */
      maintainOrderAddMaintainDeviceRecordModal: false,
      maintainOrderAddMaintainDeviceRecordId: false,

      data: [
        {
          title: '硬盘损坏',
          description: '1、易流查询历史视频',
          content: '2、微信小程序：智行运维宝->芯片码->最新自检->存储信息：HD1显示状态“挂载”,DVR内部存储NAND显示“异常/非挂载以外的任何状态”：表示硬盘故障，建议格式化硬盘；',
          dispose: '3、安排上门维修更换硬盘',
          imgSrc: '/ZT/HardDiskDamage.png',
          pdfSrc: '/ZT/ZT-HardDiskDamage.pdf'
        },
        {
          title: '设备主机模块损坏',
          description: '1、安排上门维修更换设备主机'
          // imgSrc: '/BSJ/A6BD/Parameterexception.jpg',
        }
      ]
    }
  },
  /**
   * 方法存储位置
   */
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    openpdf (e) {
      this.Iframemodal = true
      this.IframeId = e
    }
  },
  /** 作为组件的数值传输字段
     */
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  /**
   * 页面加载执行的代码
   * 可调用方法存储位置中的方法
   */
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>

<!--样式库-->
<style scoped>

</style>
